export class PayoffResponseBeanList {
   statusCode: string;
   statusMessage: string;
   contractNumber: string;
   scheduleNumber: number;
   contractType: string;
   quoteNumber: string;
   quoteAmount: string;
   qtBuyOutDt: string;
   payoffExpDate: string;
   payoffRequestedDate: string;
   totalAssetCount: string;
   vinNum: string;
   terminatedAssetsCount: number;
   terminatedAssetsList: string[];
   thirdPartyNum: string;
   payOffType: string;
   onlinePayFlag: string;
   quoteCreatedTimestamp:string;
}